import React from 'react';
import VideoPlayerModal from '../common/VideoPlayerModal';
import ShareTextModal from '../common/ShareTextModal';
import { AudioPlayerModal } from '../common/AudioPlayer';
import { LyricsRecordModal } from './LyricsRecordPreview';
import { shareMediaType, toAudioPlayerMusic } from './creationRecordUtils';

export default function CreationRecordModals({
  audioModalRecord,
  by,
  getTypeLabel,
  lyricsModalRecord,
  onCloseAudio,
  onCloseLyrics,
  onCloseShare,
  onCloseVideo,
  shareModal,
  t,
  videoModalUrl,
}) {
  return (
    <>
      <VideoPlayerModal open={!!videoModalUrl} src={videoModalUrl} onClose={onCloseVideo} />
      <AudioPlayerModal
        open={!!audioModalRecord}
        music={audioModalRecord ? toAudioPlayerMusic(audioModalRecord) : null}
        title={audioModalRecord ? getTypeLabel(audioModalRecord.type) : ''}
        meta={audioModalRecord?.date}
        onClose={onCloseAudio}
        t={t}
      />
      <LyricsRecordModal
        record={lyricsModalRecord}
        title={getTypeLabel('LYRICS_GENERATION')}
        emptyText={t('creationRecord.noPreview')}
        onClose={onCloseLyrics}
      />
      <ShareTextModal
        open={shareModal.open}
        title={t('creationRecord.share')}
        placeholder={t('creationRecord.enterShareText')}
        maxLength={shareModal.maxLength}
        platform={shareModal.platform}
        mediaUrl={shareModal.shareUrl}
        mediaType={shareModal.record ? shareMediaType(shareModal.record) : 'image'}
        by={by}
        onConfirm={onCloseShare}
        onCancel={onCloseShare}
      />
    </>
  );
}
